var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-center position-ref full-height"},[_c('div',{staticClass:"content"},[_c('Title',{attrs:{"text":"zackijack"}}),_c('Links',{attrs:{"links":_vm.links}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }